import React, { useState } from 'react';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';
import { DeptMicStyleNum } from '../ProductDeptMicStyleNum/ProductDeptMicStyleNum';
import ProductExtraVerbiage from '../ProductExtraVerbiage/ProductExtraVerbiage';
import ItemNumber from '../ProductItemNumber/ProductItemNumber';
import ProductMisc from '../ProductMisc/ProductMisc';

export function ProductDescription(props) {
  const [descriptionOpened, setDescriptionOpened] = useState(props.open || false);

  const descriptionToggled = (value) => {
    setDescriptionOpened(value === false ? false : !descriptionOpened);
  };

  return (
    <>
      <div className='panel product-description-wrapper'>
        <button
          type='button'
          onClick={descriptionToggled}
          className='panel-title product-description-title'
          aria-controls={`product-description-${props.contentData.productId}`}
          aria-expanded={descriptionOpened === true ? 'true' : 'false'}
        >
          Description
          {descriptionOpened === true ? (
            <i className='panel-icon expanded'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.84 48.84' aria-hidden='true'>
                <title>plus</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M47.84,23.41H25.47V1a1,1,0,0,0-2,0v22.4H1a1,1,0,0,0,0,2H23.45v22.4a1,1,0,1,0,2,0V25.43H47.84a1,1,0,1,0,0-2Z' />
                  </g>
                </g>
              </svg>
            </i>
          ) : (
            <i className='panel-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.84 48.84' aria-hidden='true'>
                <title>plus</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M47.84,23.41H25.47V1a1,1,0,0,0-2,0v22.4H1a1,1,0,0,0,0,2H23.45v22.4a1,1,0,1,0,2,0V25.43H47.84a1,1,0,1,0,0-2Z' />
                  </g>
                </g>
              </svg>
            </i>
          )}
        </button>
        <div
          className={`col-sm-12 product-description ${descriptionOpened === true ? '' : 'hidden'}`}
          id={`product-description-${props.contentData.productId}`}
        >
          <ItemNumber contentData={props.contentData} />
          <ProductExtraVerbiage contentData={props.contentData} passedAppFunctions={props.passedAppFunctions} />
          {props.contentData.preOrder && props.contentData.preOrderText ? (
            <div id='preorder-alert' className='alert alert-warning' role='alert'>
              <SetInnerHTML innerHTML={props.contentData.preOrderText} />
            </div>
          ) : (
            ''
          )}
          <SetInnerHTML innerHTML={props.contentData.longDescription} />
          {props.contentData.gwpEspot ? <SetInnerHTML innerHTML={props.contentData.gwpEspot} /> : ''}
          {props.contentData.promotionCopy ? <SetInnerHTML innerHTML={props.contentData.promotionCopy} /> : ''}
          <DeptMicStyleNum contentData={props.contentData} />
        </div>
      </div>
    </>
  );
}

export default ProductDescription;
